// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__2qBgr","emails":"CreateEditClinics_emails__2JYid","emailTagLabel":"CreateEditClinics_emailTagLabel__2I0t6"};